module.exports = __webpack_public_path__ + "static/img/notebook_right_2.c24335f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notebook_right_2.png
// module id = S65s
// module chunks = 0